import React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { PayrollStatus } from 'modules/payroll_bundle/lib/enums'
import { PayrollPhaseDefineStatus } from 'modules/payroll_bundle/store/models/PolicyPeriod'

export interface CollabStatusDescription {
  status: PayrollStatus
  title: string
  description: string
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  disabled?: boolean
  action: () => void
}

type CollabCopyData = Pick<CollabStatusDescription, 'title' | 'description' | 'icon'>

export function copiesForStatus(status: PayrollPhaseDefineStatus): CollabCopyData {
  switch (status) {
    case PayrollStatus.PREPARATION:
      return {
        title: i18n.t(
          `payroll_bundle.policy_period.cycle_process.collaborate_widget.preparation.title`
        ),
        description: i18n.t(
          `payroll_bundle.policy_period.cycle_process.collaborate_widget.preparation.description`
        ),
        icon: iconForStatus(status),
      }
    case PayrollStatus.SUPPLEMENTS_DEFINITION:
      return {
        title: i18n.t(
          `payroll_bundle.policy_period.cycle_process.collaborate_widget.supplements_definition.title`
        ),
        description: i18n.t(
          `payroll_bundle.policy_period.cycle_process.collaborate_widget.supplements_definition.description`
        ),
        icon: iconForStatus(status),
      }
    case PayrollStatus.UNDER_REVIEW:
      return {
        title: i18n.t(
          `payroll_bundle.policy_period.cycle_process.collaborate_widget.under_review.title`
        ),
        description: i18n.t(
          `payroll_bundle.policy_period.cycle_process.collaborate_widget.under_review.description`
        ),
        icon: iconForStatus(status),
      }
    default: {
      const _exhaustiveCheck: never = status
      throw new Error(`Unhandled status: ${_exhaustiveCheck}`)
    }
  }
}
function iconForStatus(
  status: PayrollPhaseDefineStatus
): React.ComponentProps<typeof Icon.Medium>['icon'] {
  switch (status) {
    case PayrollStatus.PREPARATION:
      return 'deny'
    case PayrollStatus.SUPPLEMENTS_DEFINITION:
      return 'pencil'
    case PayrollStatus.UNDER_REVIEW:
      return 'validation'
    default: {
      const _exhaustiveCheck: never = status
      throw new Error(`Unhandled status: ${_exhaustiveCheck}`)
    }
  }
}
